import { PaneArea, RequireByKey, TextAttrs as TextAttrsRaw } from '../../../types/shared'
import Callout, { ICalloutAttrs } from '../../canvas/callout/callout_v1'
import { StyleDialogOpener } from '../../modals/element_style'
import ElementModel from '../../models/element'
import PaneModel from '../../models/pane'

type Area = PaneArea
type TextAttrs = RequireByKey<TextAttrsRaw, 'text' | 'textAlign' | 'fillStyle' | 'border'>
type Attrs = ICalloutAttrs & TextAttrs
type PartialAttrs = Partial<Attrs>

class CalloutCreator extends Callout<Attrs> {
  isCreator = true
  mouseUps = 0
  openStyleDialog: StyleDialogOpener<CalloutCreator>

  constructor(
    startArea: Area,
    values: PartialAttrs,
    model: PaneModel,
    openStyleDialog: StyleDialogOpener<CalloutCreator>,
    toolsCallback: () => void
  ) {
    super(values, model)

    this.openStyleDialog = openStyleDialog
    this.attrs.x1 = this.attrs.x2 = startArea.x
    this.attrs.y1 = this.attrs.y2 = startArea.y
    this.attrs.text = ''
    this.toolsCallback = toolsCallback

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  onMouseUp(area: PaneArea) {
    this.mouseUps++
    if (this.mouseUps > 1) {
      this.attrs.x2 = area.x
      this.attrs.y2 = area.y
      this.isCreatorDialogOpen = true
      this.openStyleDialog(
        this,
        (values) => {
          this.set(values)
          this.release()
          this.replaceMyself(Callout.fromObject<Callout>(this.attrs, this.model))
          this.toolsCallback()
        },
        () => {
          const instance = ElementModel.findByAttribute<ElementModel>('instance', this)
          instance?.destroy()
        }
      )
    }
  }

  onMouseMove(area: Area) {
    this.attrs.x2 = area.x
    this.attrs.y2 = area.y
    return this.trigger('change')
  }
}

export default CalloutCreator
